<template>
<validation-observer ref="AddLeaveRequestForm" @ok.prevent="formSubmitted">
    <b-form @submit.prevent="formSubmitted">
      <b-row>
        <b-col md="6" v-if="IsAdmin()">
            <b-form-group label="Employee*" label-for="employee">
              <validation-provider v-slot="{ errors }" name="Employee" rules="required">
              <b-form-select v-model="newRequest.employeeId" id="employee" :options="formattedEmployeeOptions" 
              value-field="id"
              text-field="fullName" :state="errors.length > 0 ? false : null" required
              /> 
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
      </b-col>
        <b-col md="6">
          <b-form-group label="Leave Type*" label-for="leave_type">
            <validation-provider 
            #default="{ errors }" name="Leave Type" rules="required">
            <b-form-select v-model="newRequest.leaveTypeId" :options="fetchLeaveType" 
            :state="errors.length > 0 ? false : null" required
            value-field="leaveTypeId"
            text-field="title"/>
            <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
           </b-form-group></b-col>
        <b-col md="6">
          <b-form-group label="Start Date*" label-for="start_date">
            <validation-provider v-slot="{ errors }" name="startDate" vid="startDate" rules="required">
            <b-form-input v-model="newRequest.startDate" id="start_date" type="date" placeholder="Choose a date" local="en" 
            :state="errors.length > 0 ? false : null" required/>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6" v-if="newRequest.leaveDurationType !== 'HalfDay'">
  <b-form-group label="End Date*" label-for="return_date">
    <validation-provider v-slot="{ errors }" name="return_date" vid="returnDate" rules="required">
      <b-form-input v-model="newRequest.returnDate" id="return_date" placeholder="Choose a date" type="date" local="en" 
      :state="errors.length > 0 ? false : null" required />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</b-col>
        <b-col md="6">
  <b-form-group label="No. of Days" label-for="no_of_days">
    <b-form-input id="no_of_days" v-model="leaveDays" readonly />
  </b-form-group>
</b-col>
        <b-col md="6">
          <b-form-group label="Leave Duration Type*" label-for="leaveDurationType">
            <validation-provider v-slot="{ errors }" name="Leave Duration Type" vid="leaveDurationType" rules="required">
            <b-form-select v-model="newRequest.leaveDurationType" :options="leaveDurationTypeOptions" required/>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
          </b-form-group></b-col>
        <b-col md="6">
          <b-form-group label="Upload File" label-for="upload_file">
            <b-form-file v-model="newRequest.file" placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..." />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Notes*" label-for="notes">
            <validation-provider name="notes" rules="required" v-slot="{ errors }">
              <b-form-textarea v-model="newRequest.notes" id="notes" placeholder="notes" rows="1" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Approving Manager*" label-for="approving_manager">
            <validation-provider v-slot="{ errors }" name="Approving Manager" vid="approving_manager" rules="required">
            <b-form-select v-model="newRequest.managerId" :options="formattedEmployeeOptions" 
            value-field="id"
            text-field="fullName" :state="errors.length > 0 ? false : null" required />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
           </b-form-group></b-col>
        <!-- submit and reset -->
        <b-col md="12" class="d-flex justify-content-between">
          <b-button type="button" @click="formSubmitted" variant="primary" :disabled="invalid">Save
        </b-button>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BFormGroup,
  BButton,
  BSpinner,
  BFormFile,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import Swal from 'sweetalert2';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { customLoader, customError, customSwal } from '@/libs/customFn';
import { IsAdmin } from "@/@core/utils/validations/permissionCheck";

export default {
  name: "AddProject",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormDatepicker,
    BFormGroup,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
  },
  props: {
    leaverequest: {
      type: Object,
      default: () => ({}),
    },
    employeeId: {
      default: () => null
    }
  },
  data() {
    return {
      invalid: false,
      
      leaveDurationTypeOptions: [
        { value: "FullDay", text: "Full Day" },
        { value: "HalfDay", text: "Half Day" },
      ],
      fileSizeError: null,
      selectedFile: null,
      newRequest:{
        employeeId: null,
        leaveTypeId: null,
        startDate: null,
        returnDate: null,
        leaveDurationType: null,
        notes: "",
        managerId: null,
        file: null,
        attachmentType: null
      },
      // optionsLeavesType: [],
    };
  },
  computed: {
    ...mapGetters("employeeModule", {
      employeeOptions: "employees",
      loading: "loading",
    }),

    leaveDays() {
    if (this.newRequest.leaveDurationType === "HalfDay") {
      return 0.5; // Set to 0.5 for half-day leave
    }
    
    if (this.newRequest.startDate && this.newRequest.returnDate) {
      const start = new Date(this.newRequest.startDate);
      const end = new Date(this.newRequest.returnDate);
      if (end >= start) {
        return Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1; // Add 1 to include both days
      }
    }
    return 0;
  },
    formattedEmployeeOptions() {
        const userData = JSON.parse(localStorage.getItem("userData"));
      return this.employeeOptions.filter(x => (IsAdmin() || x.refId != userData.id)).map(employee => {
        if(employee.id != this.employeeId){
          return {
          ...employee,
          fullName: `${employee.firstName} ${employee.lastName}`,
          }
        }else{
          return {
          ...employee,
          fullName: `${employee.firstName} ${employee.lastName}`,
          }
        }
      });
    },
    ...mapGetters("leavetypeModule", {
      leaveTypeOptions: "leavetypes",
      loading: "loading",
    }),

     fetchLeaveType() {
      return this.leaveTypeOptions.filter((type) => type.status === 'ACTIVATE')
    }

  },
  methods: {
    ...mapActions("leaverequestModule", ["getLeaveRequestEmployeeAction",
      "getLeaveRequestSubordinatesAction", "addLeaveRequestAction"]),
      ...mapActions("employeeModule", ["getEmployeeListAction"]),

       ...mapActions("leavetypeModule", ["getLeaveTypeListAction"]),

       fileError() {
      this.$swal({
        title: "Error!",
        text: " Please select a file!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    async formSubmitted() {
      const isValid = await this.$refs.AddLeaveRequestForm.validate();
      if (isValid) {
    this.loading = true;
    const loader = Swal.fire({
        title: 'Processing...',
        text: 'Please wait while the Leave request is being submitted',
        allowOutsideClick: () => !Swal.isLoading(),
        showConfirmButton: false,
        showCancelButton: false,
        buttonsStyling: false,
        willOpen: () => {
            Swal.showLoading();
        }
    });

    const maxSize = 20 * 1024 * 1024;
        if (this.selectedFile && this.selectedFile.size > maxSize) {
          alert('File size exceeds 20 MB limit. Please choose a smaller file.');
          this.submitting = false;
          return;
        }

    try {
     
      let docForm = new FormData();
          docForm.append("employeeId", (IsAdmin()) ? this.newRequest.employeeId : this.employeeId);
          docForm.append("leaveTypeID", this.newRequest.leaveTypeId);
          docForm.append("startDate", this.newRequest.startDate);
          docForm.append("returnDate", this.newRequest.leaveDurationType === "HalfDay" 
            ? this.newRequest.startDate 
            : this.newRequest.returnDate);
          docForm.append("Status", "PENDING");
          docForm.append("notes", this.newRequest.notes);
          docForm.append("leaveDurationType", this.newRequest.leaveDurationType);
          docForm.append("managerId", this.newRequest.managerId);
          docForm.append("attachmentType", 0);
          docForm.append("file", this.newRequest.file);

          this.addDocLoader = customLoader('Please wait while your request is being submitted');

        this.addLeaveRequestAction(docForm).then(() => {
           // if (response.success) {
              this.success();
              this.newRequest.id = response.result.id;
              this.$emit("LeaveRequestAdded");
              //window.location.reload();

            // } else {
            //   customError(response, 'Error');
            // }
           this.getLeaveRequestEmployeeAction();
           this.getLeaveRequestSubordinatesAction();
            this.addDocLoader.close();
          }).catch((error) => {
            this.addDocLoader.close();
            customError(error.response.data, "Error");
          });

          this.newRequest.id = this.employeeDocs.length ? this.employeeDocs[this.employeeDocs.length - 1].id + 1 : 1;
          this.employeeDocs.push({ ...this.newRequest });
          this.getLeaveRequestEmployeeAction();
         this.getLeaveRequestSubordinatesAction();

    } catch (error) {
      this.error(error.response.data);
    } finally {
          this.submitting = false;
          this.getLeaveRequestEmployeeAction();
          this.getLeaveRequestSubordinatesAction();
        }
      }
    },

    success() {
      this.$swal({
        title: 'Leave Request added!',
        text: 'You have successfully added the Leave Request!',
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$emit('LeaveRequestAdded');
        }
      });
    },

    error(data) {
      this.$swal('Error!', this.getErrorString(data) || 'Failed!', 'error');
    },

    getErrorString(data) {
      let msg = "<div><p>Cannot post your request due to the following errors:</p>";
      if (data.errors) {
        for (let prop in data.errors) {
          msg += `<p>${prop.replace("$.", "")}: ${data.errors[prop].toString().replace("$.", "")}</p>`;
        }
      } else if (data.message) {
        msg += `<p>${data.message}</p>`;
      }
      return msg + "</div>";
    },

    resetForm() {
      this.newRequest = {
        employeeId: null,
        leaveType: null,
        startDate: null,
        returnDate: null,
        leaveDurationType: null,
        notes: null,
        managerId: null,
        file: null
      }
    }
  },
  async mounted() {
    this.getLeaveRequestEmployeeAction();
     await this.getLeaveTypeListAction();
     await this.getEmployeeListAction();
    await this.getLeaveRequestSubordinatesAction();
  },
  setup(){
    return {
      IsAdmin
    }
  },

  watch: {
  'newRequest.leaveDurationType': function (newValue) {
    if (newValue === 'HalfDay') {
      this.newRequest.returnDate = this.newRequest.startDate; 
    }
  },
  'newRequest.startDate': function (newValue) {
    if (this.newRequest.leaveDurationType === 'HalfDay') {
      this.newRequest.returnDate = newValue; 
    }
  }
},
};
</script>
